export enum AlarmState {
	Alarm = 'Alarm',
	Deactivated = 'Deactivated',
	None = 'None',
	Ok = 'Ok',
}
